<!-- audit-trail.component.html -->
<div *ngIf="auditLogs?.length">
    <h3>Audit Trail</h3>
    <table>
      <thead>
        <tr>
          <th>Timestamp</th>
          <th>User</th>
          <th>Action</th>
          <th>IP Address</th>
          <th>Details</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let log of auditLogs">
          <td>{{ log.timestamp | date: 'short' }}</td>
          <td>{{ log.userName }}</td>
          <td>{{ log.action }}</td>
          <td>{{ log.ipAddress }}</td>
          <td>{{ log.details | json }}</td>
        </tr>
      </tbody>
    </table>
  </div>
